import * as React from 'react'
import { useFormContext } from 'react-hook-form'

import {
  FieldElementWrapperProps,
  FieldWrapper
} from '~/components/field-wrapper/FieldWrapper'
import { useFieldError } from '~/components/form/useFieldError'
import { useFormCustomContext } from '~/components/form/useFormCustomContext'
import { PasswordInput } from '~/components/password-input/PasswordInput'
import { cn } from '~/styled'

type PasswordFieldProps = React.ComponentProps<typeof PasswordInput> &
  Omit<FieldElementWrapperProps, 'label'> & {
    label?: string
  }

export const PasswordField = ({
  className,
  hideLabel,
  label = 'Password',
  name,
  prompt = undefined,
  description,
  validation,
  appearance,
  theme,
  ...remainingProps
}: PasswordFieldProps) => {
  const { register } = useFormContext()
  const context = useFormCustomContext()
  const { error } = useFieldError(name)

  const ref = validation ? register(validation) : register
  const formAppearance = context?.appearance || appearance
  const formTheme = context?.theme ?? theme

  return (
    <FieldWrapper
      description={description}
      error={error}
      fieldId={name}
      hideLabel={hideLabel}
      label={label}
      prompt={prompt}
      required={Boolean(validation?.required)}
      appearance={formAppearance}
      className={cn('relative', className)}
    >
      <PasswordInput
        autoComplete="current-password"
        name={name}
        id={name}
        ref={ref}
        appearance={formAppearance}
        theme={formTheme}
        {...(error !== undefined && { state: 'error' })}
        {...remainingProps}
      />
    </FieldWrapper>
  )
}

PasswordField.displayName = 'PasswordField'
